// Group ページの 1 行に振る HTML id を組み立てる。検索 UI の deep link 先になるので
// 文字列の組み立て規約を 1 か所に集約しておく。
//
// key は dicts.json 由来の flat key (例: `filename/foo.bar.baz`) でスラッシュやドットを
// 含む。HTML5 の id 仕様上はほぼ任意の文字を許容するが、URL fragment + getElementById で
// 安全に往復できる形を保つため encodeURIComponent でエスケープしている。
// CSS セレクタ (`#xxx`) では参照しない (document.getElementById のみ) ため `:` の扱いは無視。
export const ROW_ID_PREFIX = 'row:';

export const rowDomId = (key: string): string => `${ROW_ID_PREFIX}${encodeURIComponent(key)}`;
